import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';

declare var IS_RUNNING_IN_APP_POOL;

export class ProspectDocumentFileClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(actorId: number, documentId: number, taskRequestId: number, fileName: string, useGenericFileName: boolean, encrypt: boolean): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/ProspectDocumentFile/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorId: actorId, documentId: documentId, taskRequestId: taskRequestId, fileName: fileName, useGenericFileName: useGenericFileName, encrypt: encrypt }

    return AjaxWrapper.get<string, any>(url, data);
  }
}

